/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React, { MouseEventHandler } from 'react';
import { Button } from 'reactstrap';

interface CollapseButtonProps {
  children: JSX.Element,
  isOpen?: boolean;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}

const CollapseButton = (props: CollapseButtonProps) => {

  const { children, isOpen = false, className, onClick = () => { }, disabled = false } = props;

  const handleClick: MouseEventHandler<HTMLElement> = (e) => {
    e.preventDefault();
    if (disabled) {
      return;
    }
    onClick();
  }

  return (
    <div className={`collapse-button d-flex align-items-center ${disabled ? 'disabled' : ''}`}>
      <Button color='link' disabled={disabled} onClick={handleClick} className={isOpen ? 'open' : ''}>
        <i className='fa fa-plus text-ThemeAccentDark' />
      </Button>
      <div className={`flex-fill pt-1 ${className ?? ''}`} onClick={handleClick} >
        {children}
      </div>
    </div>
  )

}

export default CollapseButton;
